/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-dupe-keys */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../../layout/head/Head"
import { DownloadTableExcel } from 'react-export-table-to-excel';
import TextField from '@mui/material/TextField';
import CPDataUpdate from "./CPDataUpdate";
import { Link } from "react-router-dom"

const CPEditForm = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Gloading, setGloading] = useState(false);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "Quarter 4(Jan- Mar)", "FEBRUARY", "MARCH", "Quarter 1(Apr- Jun)", "May", "JUNE", "Quarter 2(Jul-Sep)", "AUGUST", "SEPTEMBER", "Quarter 3(Oct- Dec)", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const today = new Date();
    const tableRef = useRef(null);
    const [Draft, setDraft] = useState(true);
    const [form, setform] = useState(false);
    const [loading, setloading] = useState(false);
    const formData = {
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month:  sessionStorage.getItem("CurrentMonthCP"),
        dummymonth: month1[sessionStorage.getItem("CurrentMonthCP")],
        year:  sessionStorage.getItem("CurrentYearCP"),
        EmploymentRefCpId: 13,
    };

    
    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentId: Number(emp),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/GetCP1param', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }

        console.log("SendData", sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/ViewalldataCP', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    console.log("Data", data)
                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2(data.employmentId)
                        setuserData(data)

                    }

                })


    };
    const generate = async () => {
        setloading(false)
        setGloading(true)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefId: Number(formData.EmploymentRefId),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }
        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs3', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        setGloading(false)
                        getdata()
                    }

                })


    };
    useEffect(() => {

        setloading(true)
        getdata()
    }, [])
    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                ////console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/CP/SubmitformCP', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/cpDashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()



    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/cpDashboard")
        getdata()



    };
    const ADDDynamic = async () => {
        setloading(false)
        const sendData = {
            EmploymentId: employmentId,
            EmploymentRefCpId: Number(formData.EmploymentRefCpId),

        }
        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/DynamicAddCP', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        setloading(true)
                        getdata()
                    } else {
                        window.location.reload()
                    }

                })


    };


    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Link to="/cpdashboard"><Button color="dark" className="m-1"><em className="icon ni ni-back-alt"></em> BACK</Button></Link>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                            {/*<NavbarDynamic/>*/}
                            <h3 style={{ marginBottom: 40 }}>Employment Return CP    <DownloadTableExcel
                                filename="CP Edit Report"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                {Draft ? null : <Button style={{ float: "right" }} color="warning" ><Icon className="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                            </DownloadTableExcel>  </h3>

                            {Draft ? <Row className="gy-4">

                                <Col md="6">
                                    <TextField sx={{ width: 200 }} disabled defaultValue={`${month1[sessionStorage.getItem("CurrentMonth")]} ${sessionStorage.getItem("CurrentYear")}`} />
                                </Col>
                                {Gloading === false ? <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col> : <Spinner color="success" />}
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Period: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                       
                                    </Row>
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <tr >
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Sno
                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Name of the Employer/ Organization Name
                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Designation of Posts
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Group

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Level

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "250px" }} >
                                                            Field & Branch

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Qualification

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Experience

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            No. of Vacancies

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Employer Category

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Name of the States/UT

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Job Nature

                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            According to 7th Pay Commission

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Required specific field*(attached sheet Field & Branch Code )
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Required 8th/10th/12th/Diploma/ Graduate/PostGraduate/ Ph.d

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            With /Without experience

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            CG- Central Govt. SG- State Govt. QG- Quasi Govt. LB- Local Bodies PV- Private Sector


                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            whether Regular/ Temporary/ Contractual/ Deputation

                                                        </th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {dataactive.length > 0 ? dataactive.map((details, index) =>

                                                        details.parentId === 0 ?
                                                            <tr scope="row" key={index}>

                                                                <td >

                                                                    <b>  {details.value}</b>

                                                                </td>



                                                            </tr> :
                                                            <CPDataUpdate keyy={index} value={details.value} form={form} setform={setform} setGTotal={setGTotal} GTotal={GTotal} edit={true} CpdetailsId={details.cpdetailsId} employmentId={employmentId} CPDataUpdate={CPDataUpdate} />

                                                    ) : null}
                                                    <tr>
                                                        <Button color="success" onClick={() => ADDDynamic()}>ADD</Button>
                                                    </tr>
                                                    

                                                </tbody>
                                            </table>

                                        </div>

                                        <div style={{ visibility: 'hidden', height: 0, width: 0 }} className="table-responsive">
                                            <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <tr >
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Sno
                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Name of the Employer/ Organization Name

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Designation of Posts
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Group

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Level

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Field & Branch

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Qualification

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Experience

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            No. of Vacancies

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Employer Category

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Name of the States/UT

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: "200px" }} >
                                                            Job Nature

                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            According to 7th Pay Commission

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Required specific field*(attached sheet Field & Branch Code )
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Required 8th/10th/12th/Diploma/ Graduate/PostGraduate/ Ph.d

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            With /Without experience

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            CG- Central Govt. SG- State Govt. QG- Quasi Govt. LB- Local Bodies PV- Private Sector


                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            whether Regular/ Temporary/ Contractual/ Deputation

                                                        </th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details, index) =>

                                                        details.parentId === 0 ?
                                                            <tr scope="row" key={index} >

                                                                <td >

                                                                    <b>  {details.value}</b>

                                                                </td>



                                                            </tr> :
                                                            <CPDataUpdate value={details.value} setform={setform} setGTotal={setGTotal} GTotal={GTotal} edit={false} CpdetailsId={details.cpdetailsId} employmentId={employmentId} CPDataUpdate={CPDataUpdate} />

                                                    ) : null}


                                                </tbody>
                                            </table>

                                        </div>



                                    </div>
                                    <div style={{ marginTop: 30, marginRight: -10 }}>
                                        <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                                <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0}}>
                                                        <tr >
                                                            <th >
                                                            * Field & Branch should be specified according to heads given below:<br></br>

                                                            Engineering, Technology, Agriculture, Medicine, Natural Science, Social Science, Miscellaneous'.
                                                            </th>
                                                        </tr>

                                                    </thead>
                                                </table>

                                        </div>   
                                    </div>
                                    <div style={{marginLeft: -5 }}>
                                        <Button color='info' onClick={() => onSaveDraft()} className="m-1">Save As Draft<em className="icon ni ni-unarchive"></em></Button>
                                        {!form ? (
                                            < Button onClick={()=> onFormSubmit()} color='success' className="m-1">Submit <em className="icon ni ni-file-check"></em></Button>
                                        ) : (
                                            < Button disabled color='danger' className="m-1">Submit <em className="icon ni ni-file-check"></em></Button>
                                        )}
                                       {/* < Button onClick={onFormSubmit} color='success'>Submit <em className="icon ni ni-file-check"></em></Button>*/}
                                        <Button color='warning' className="m-1" onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard<em className="icon ni ni-signout"></em></Button>
                                    </div>
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default CPEditForm;
